import {SimplePresentation, SimplePresentationRunnerController} from "../../../SimplePresentationRunner";
import {XW2GameMode, XwaysHoarder2} from "../../../XwaysHoarder2";
import {gsap} from "gsap";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {SymbolStates} from "../../../reels/symbols/BasicSymbol";
import {XSplitSymbol} from "../../../reels/symbols/XSplitSymbol";
import {XwaysHoarder2Sound} from "../../../sound/XwaysHoarder2Sound";


export class SuperFsBeforeStart implements SimplePresentation {
    name: string = "SuperFsBeforeStart";
    private _stickyXS: XSplitSymbol[];
    private _tl: gsap.core.Timeline;
    private bingeStart:boolean = false;

    shouldRun(): boolean {
        return XwaysHoarder2.model.isSuperFreespinStarting;
    }

    start(controller: SimplePresentationRunnerController): void {
        this._tl = gsap.timeline({
            onComplete: () => {
                XwaysHoarder2.plusFsView.resetAnimations();
                controller.setSkipCallback();
                controller.finish();
            }}
        );
        XwaysHoarder2.trashSymView.isSkipped = false;

        this._stickyXS = [];
        const currentLit: number [] = XwaysHoarder2.model.data.currentTopBarProgression;
        let currentCountTotal: number = 0;
        currentLit.forEach((val) => {
            currentCountTotal += val;
        });

        const nextLit: number [] = XwaysHoarder2.model.data.nextTopBarProgression;
        let nextCountTotal: number = 0;
        nextLit.forEach((val) => {
            nextCountTotal += val;
        });

        [1, 2, 3, 4].forEach((reelId: number) => {
            [0, 1, 2].forEach((symId: number) => {
                if (XwaysHoarder2.model.data.reelsAfterCollapse[reelId][symId] === "XS") {
                    this._stickyXS.push(<XSplitSymbol>XwaysHoarder2.reelView.reels[reelId].model.getVisibleSymbolAt(symId).positionable);
                }
            })
        })


        this._tl.add(this.getIndicatorAnimation(currentCountTotal, nextCountTotal));

        XwaysHoarder2.screenInteractive.setInteractiveState(true);
        XwaysHoarder2.screenInteractive.clickArea.on('pointerdown', () => {
            XwaysHoarder2.screenInteractive.setInteractiveState(false);
            this.onSkip();
        });

    }

    private onSkip():void{
        XwaysHoarder2.trashSymView.isSkipped = true;
        this._tl.totalProgress(1);
        XwaysHoarder2Sound.stopSound(XwaysHoarder2Sound.FS_PLUS);

        [XwaysHoarder2Sound.SCREAM_M4, XwaysHoarder2Sound.SCREAM_M5, XwaysHoarder2Sound.SCREAM_M6].forEach((soundName) => {
            XwaysHoarder2Sound.stopSound(soundName);
        });

        XwaysHoarder2Sound.stopSound(XwaysHoarder2Sound.RADIATION_ANIMATION);

        if (this.bingeStart) {
            XwaysHoarder2Sound.fadeOutAndStopSound({
                name: XwaysHoarder2Sound.BINGE_INTRO,
                duration: 100,
                to: 0
            });
            XwaysHoarder2Sound.stopSound(XwaysHoarder2Sound.BINGE_INTRO);
            this.bingeStart = false;
        }

    }

    private getIndicatorAnimation(lastProgress: number, newProgress: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        if (newProgress > lastProgress) {
            const updateConf = XwaysHoarder2.fsIndicators.calculateUpdatePositions(lastProgress, newProgress);
            const diff: number = this.freespinWonNumber();
            let count: number = 1;

            [0, 1, 2, 3].forEach((boxIndex) => {
                switch (boxIndex) {
                    case 0:
                        if (updateConf.slot0.nrOfUpdates > 0) {
                            tl.add(this.getstickyAnim(updateConf.slot0.nrOfUpdates));
                            tl.add(XwaysHoarder2.fsIndicators.playSpineToLit(boxIndex, updateConf.slot0.fromId, updateConf.slot0.toId, updateConf), "<");
                            if (updateConf.slot0.toId === 3) {
                                tl.add(XwaysHoarder2.fsReelAnimHandler.getTrashAnimation(0, XwaysHoarder2.model.reels));
                                tl.add(
                                    XwaysHoarder2.plusFsView.playIndicatorSpine(0, () => {
                                        SlotGame.keypadPlugin.setZeroBetSpinCounter(diff + count++);
                                    })
                                );
                                tl.add(() => {
                                }, "+=0.3");
                            }
                        }
                        break;
                    case 1:
                        if (updateConf.slot1.nrOfUpdates > 0) {
                            tl.add(this.getstickyAnim(updateConf.slot1.nrOfUpdates));
                            tl.add(XwaysHoarder2.fsIndicators.playSpineToLit(boxIndex, updateConf.slot1.fromId, updateConf.slot1.toId, updateConf), "<");
                            if (updateConf.slot1.toId === 3) {
                                tl.add(XwaysHoarder2.fsReelAnimHandler.getTrashAnimation(1, XwaysHoarder2.model.reels));
                                tl.add(
                                    XwaysHoarder2.plusFsView.playIndicatorSpine(1, () => {
                                        SlotGame.keypadPlugin.setZeroBetSpinCounter(diff + count++);
                                    })
                                );
                                tl.add(() => {
                                }, "+=0.3");
                            }
                        }
                        break;
                    case 2:
                        if (updateConf.slot2.nrOfUpdates > 0) {
                            tl.add(this.getstickyAnim(updateConf.slot2.nrOfUpdates));
                            tl.add(XwaysHoarder2.fsIndicators.playSpineToLit(boxIndex, updateConf.slot2.fromId, updateConf.slot2.toId, updateConf), "<");
                            if (updateConf.slot2.toId === 3) {
                                tl.add(XwaysHoarder2.fsReelAnimHandler.getTrashAnimation(2, XwaysHoarder2.model.reels));
                                tl.add(
                                    XwaysHoarder2.plusFsView.playIndicatorSpine(2, () => {
                                        SlotGame.keypadPlugin.setZeroBetSpinCounter(diff + count++);
                                    })
                                );
                                tl.add(() => {
                                }, "+=0.3");
                            }
                        }
                        break;
                    case 3:
                        if (updateConf.slot3.nrOfUpdates > 0) {
                            tl.add(this.getstickyAnim(updateConf.slot3.nrOfUpdates));
                            tl.add(XwaysHoarder2.fsIndicators.playSpineToLit(boxIndex, updateConf.slot3.fromId, updateConf.slot3.toId, updateConf), "<");
                            if (updateConf.slot3.toId === 3) {
                                this.bingeStart = true;
                                tl.add(
                                    XwaysHoarder2.plusFsView.playIndicatorSpine(3, () => {
                                        SlotGame.keypadPlugin.setZeroBetSpinCounter(diff + count++);
                                    })
                                );
                                tl.add(XwaysHoarder2.bonusDoors.closeGate(XW2GameMode.BINGE_SPINS));
                                tl.add(XwaysHoarder2.fsReelAnimHandler.getTrashAnimation(3, XwaysHoarder2.model.reels));
                                tl.add(() => {
                                    XwaysHoarder2.fsIndicators.hide();
                                }, "<");
                                tl.add(() => {
                                }, "+=0.3");
                            }
                        }
                        break;
                }
            });
        }
        return tl;
    }

    private getstickyAnim(num: number): gsap.core.Timeline {
        const animTL: gsap.core.Timeline = gsap.timeline();

        let lockSoundPlayed:boolean = false;
        for (let i: number = 0; i < num; i++) {
            const symbol: XSplitSymbol | undefined = this._stickyXS.shift();
            if (symbol) {
                animTL.add((<XSplitSymbol>symbol).getStateAnimation(SymbolStates.STICKY), 0);
                if (!lockSoundPlayed) {
                    animTL.add(() => {
                        XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.TAPE_ON);
                    }, "<");
                    lockSoundPlayed = true;
                }
                XwaysHoarder2.reelView.reels[symbol.reel.id].lockSpecialSymAndAddDummyBelow(symbol.symID, "D", true);
            }
        }
        return animTL;
    }

    private freespinWonNumber(): number {
        let noOFspinsWOn: number = 0;
        let scatterCount: number = 0;
        [1, 2, 3, 4, 5].forEach((reelId: number) => {
            [0, 1, 2].forEach((symId: number) => {
                if (XwaysHoarder2.model.data.reels[reelId][symId] === "SC" || XwaysHoarder2.model.data.reels[reelId][symId] === "SSC") {
                    scatterCount++;
                }
            });
        });
        if (scatterCount === 3) {
            noOFspinsWOn = 7;
        } else if (scatterCount === 4) {
            noOFspinsWOn = 10;
        } else if (scatterCount === 5) {
            noOFspinsWOn = 13;
        }

        return noOFspinsWOn;
    }

}